module.exports = __webpack_public_path__ + "img/balances.ca4083ba.svg";